import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataModalEditPersonalInfo } from '../../../../../redux/actions/partials/modals/modalEditPersonalInfo';
import { handleChangeDataModalEditEmail } from '../../../../../redux/actions/partials/modals/modalEditEmail';
import { handleChangeDataModalEditMobile } from '../../../../../redux/actions/partials/modals/modalEditMobile';

import BottomSheetEditPersonalInfo from "./sheets/BottomSheetEditPersonalInfo";


const PersonalInfo = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { isMobile } = useSelector(state => state.general);
	const { profile } = useSelector(state => state.login);


	const shoModalEditPersonalInfo = () => {
		dispatch(handleChangeDataModalEditPersonalInfo('isOpen', true));
		setTimeout(() => dispatch(handleChangeDataModalEditPersonalInfo('isActive', true)), 0);
	};

	const shoModalEditEmail = () => {
		dispatch(handleChangeDataModalEditEmail('isOpen', true));
		setTimeout(() => dispatch(handleChangeDataModalEditEmail('isActive', true)), 0);
	};

	const shoModalEditMobile = () => {
		dispatch(handleChangeDataModalEditMobile('isOpen', true));
		setTimeout(() => dispatch(handleChangeDataModalEditMobile('isActive', true)), 0);
	};

	

    return (
    	<>

    	{isMobile ?
    	<div className="lg:rounded-medium relative styles-Frame-profile-content mb-4 bg-neutral-000">
    		<div className="flex justify-between items-center lg:py-4 px-4">
    			<div className="break-words py-3 styles-ProfileCard-title-mobileHeader">
    				<div className="flex items-center grow">
    					<div className="flex shrink-0 ml-2 cursor-pointer" onClick={() => navigate(-1)} >
    						<ArrowForwardIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} />
    					</div>
    					<p className="grow text-h5 text-neutral-900 mb-0">
    						<span className="relative">اطلاعات حساب کاربری</span>
    					</p>
    				</div>
    			</div>
    		</div>
    	</div>
    	:''}

    	<div className="lg:rounded-medium relative styles-Frame-profile-content mb-4 bg-neutral-000">
			<div className="px-6 pb-6 flex flex-col lg:grid lg:grid-cols-2">
				
				<div className="bg-neutral-000 flex justify-between items-center py-3 lg:py-4 styles-InfoCard">
					<div>
						<div className="flex items-center">
							<p className="text-body-1 text-neutral-500 ml-1">نام و نام خانوادگی</p>
						</div>
						<p className="text-subtitle-strong text-neutral-700 styles-InfoCard-value">{profile.fname} {profile.lname}</p>
					</div>
					<div className="cursor-pointer" >
						<span className="hidden lg:inline-block">
							<div className="flex">
								{ profile.fname !== null ?
									<EditIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} onClick={shoModalEditPersonalInfo} />
								:
									<AddIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} onClick={shoModalEditPersonalInfo} />
								}
							</div>
						</span>
						<span className="inline-block lg:hidden">
							<div className="flex text-neutral-400">
								{ profile.fname !== null ?
									<ChevronLeftIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}} onClick={(shoModalEditPersonalInfo)} />
								:
									<AddIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} onClick={shoModalEditPersonalInfo} />
								}
							</div>
						</span>
					</div>
				</div>

				<div className="bg-neutral-000 flex justify-between items-center py-3 lg:py-4 styles-InfoCard">
					<div>
						<div className="flex items-center">
							<p className="text-body-1 text-neutral-500 ml-1">کد ملی</p>
						</div>
						<p className="text-subtitle-strong text-neutral-700 styles-InfoCard-value">{profile.national_code}</p>
					</div>
					<div className="cursor-pointer">
						<span className="hidden lg:inline-block">
							<div className="flex">
								{ profile.national_code !== null ?
									<EditIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} onClick={shoModalEditPersonalInfo} />
								:
									<AddIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} onClick={shoModalEditPersonalInfo} />
								}
							</div>
						</span>
						<span className="inline-block lg:hidden">
							<div className="flex text-neutral-400">
								{ profile.national_code !== null ?
									<ChevronLeftIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}} onClick={shoModalEditPersonalInfo} />
								:
									<AddIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} onClick={shoModalEditPersonalInfo} />
								}
							</div>
						</span>
					</div>
				</div>

				<div className="bg-neutral-000 flex justify-between items-center py-3 lg:py-4 styles-InfoCard">
					<div>
						<div className="flex items-center">
							<p className="text-body-1 text-neutral-500 ml-1 my-0">شماره موبایل</p>
							<div className="rounded-large px-2 text-caption-strong text-neutral-000 bg-hint-object-success">تاییدشده</div>
						</div>
						<p className="text-subtitle-strong text-neutral-700 styles-InfoCard-value">{profile.mobile}</p>
					</div>
					<div className="cursor-pointer">
						<span className="hidden lg:inline-block">
							<div className="flex">
								<EditIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} onClick={shoModalEditMobile} />
							</div>
						</span>
						<span className="inline-block lg:hidden">
							<div className="flex text-neutral-400">
								<ChevronLeftIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}} onClick={shoModalEditMobile} />
							</div>
						</span>
					</div>
				</div>

				<div className="bg-neutral-000 flex justify-between items-center py-3 lg:py-4 styles-InfoCard">
					<div>
						<div className="flex items-center">
							<p className="text-body-1 text-neutral-500 ml-1">ایمیل</p>
						</div>
						<p className="text-subtitle-strong text-neutral-700 styles-InfoCard-value">{profile.email}</p>
					</div>
					<div className="cursor-pointer">
						<span className="hidden lg:inline-block">
							<div className="flex">
								{ profile.email !== null ?
									<EditIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} onClick={shoModalEditEmail} />
								:
									<AddIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} onClick={shoModalEditEmail} />
								}
							</div>
						</span>
						<span className="inline-block lg:hidden">
							<div className="flex text-neutral-400">
								{ profile.email !== null ?
									<ChevronLeftIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}} onClick={shoModalEditEmail} />
								:
									<AddIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} onClick={shoModalEditEmail} />
								}
							</div>
						</span>
					</div>
				</div>

				{/*<div className="bg-neutral-000 flex justify-between items-center py-3 lg:py-4 styles-InfoCard">
					<div>
						<div className="flex items-center">
							<p className="text-body-1 text-neutral-500 ml-1">رمز عبور</p>
						</div>
						<p className="text-subtitle-strong text-neutral-700 styles-InfoCard-value">•••••••</p>
					</div>
					<div className="cursor-pointer">
						<span className="hidden lg:inline-block">
							<div className="flex">
								<EditIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} />
							</div>
						</span>
						<span className="inline-block lg:hidden">
							<div className="flex text-neutral-400">
								<ChevronLeftIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}} />
							</div>
						</span>
					</div>
				</div>*/}

				<div className="bg-neutral-000 flex justify-between items-center py-3 lg:py-4 styles-InfoCard">
					<div>
						<div className="flex items-center">
							<p className="text-body-1 text-neutral-500 ml-1">تاریخ تولد</p>
						</div>
						{ profile.birth_date !== null && 
							<p className="text-subtitle-strong text-neutral-700 styles-InfoCard-value">{profile.birth_date}</p>
						}
					</div>
					<div className="cursor-pointer">
						<span className="hidden lg:inline-block">
							<div className="flex">
								{ profile.birth_date !== null ?
									<EditIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} onClick={shoModalEditPersonalInfo} />
								:
									<AddIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} onClick={shoModalEditPersonalInfo} />
								}
							</div>
						</span>
						<span className="inline-block lg:hidden">
							<div className="flex text-neutral-400">
								{ profile.birth_date !== null ?
									<ChevronLeftIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}} onClick={shoModalEditPersonalInfo} />
								:
									<AddIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} onClick={shoModalEditPersonalInfo} />
								}
							</div>
						</span>
					</div>
				</div>

				{/*<div className="bg-neutral-000 flex justify-between items-center py-3 lg:py-4 styles-InfoCard">
					<div>
						<div className="flex items-center">
							<p className="text-body-1 text-neutral-500 ml-1">شغل</p>
						</div>
					</div>
					<div className="cursor-pointer" >
						<span className="hidden lg:inline-block">
							<div className="flex">
								<AddIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} />
							</div>
						</span>
						<span className="inline-block lg:hidden">
							<div className="flex text-neutral-400">
								<AddIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} />
							</div>
						</span>
					</div>
				</div>

				<div className="bg-neutral-000 flex justify-between items-center py-3 lg:py-4 styles-InfoCard">
					<div>
						<div className="flex items-center">
							<p className="text-body-1 text-neutral-500 ml-1">کد اقتصادی</p>
						</div>
					</div>
					<div className="cursor-pointer">
						<span className="hidden lg:inline-block">
							<div className="flex">
								<AddIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} />
							</div>
						</span>
						<span className="inline-block lg:hidden">
							<div className="flex text-neutral-400">
								<AddIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} />
							</div>
						</span>
					</div>
				</div>*/}

			</div>
		</div>

		{/*
		<div className="lg:rounded-medium relative styles-Frame-profile-content mb-4 bg-neutral-000">
			<div className="flex justify-between items-center lg:py-4 px-4">
				<div className="break-words py-3">
					<div className="flex aligm-items-center grow">
						<p className="grow text-h5 text-neutral-900 mb-0">
							<span className="relative">اطلاعات حقوقی</span>
						</p>
					</div>
					<div className="mt-2 styles-Title-line styles-Title-line-red">

					</div>
				</div>
			</div>
			<div className="px-6 lg:py-6 flex flex-col items-start gap-2">
				<span className="text-neutral-500 text-body-1">
					این گزینه برای کسانی است که نیاز به خرید سازمانی (با فاکتور رسمی و گواهی ارزش‌افزوده) دارند.
				</span>
				<span className="profile-company-info">
					<span className="inline-flex items-center styles-Anchor-secondary text-button-2 cursor-pointer" >
						<span>ثبت اطلاعات حقوقی</span>
						<div className="flex">
							<ChevronLeftIcon sx={{width: '18px', height: '18px', fill: 'var(--color-icon-secondary)'}} />
						</div>
					</span>
				</span>
			</div>
		</div>
		*/}


		{ isMobile &&
			<BottomSheetEditPersonalInfo />
		}


		</>
    );
}

export default PersonalInfo;